import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button, Label, FormGroup, Col, Form, Input } from 'reactstrap';
import FormWrapper from './../../../commonComponents/formWrapper/FormWrapper.container';
import { sharedLabelsPath } from "../../../../reducers/common/localization";
import { Utils } from './../../../../utils/utils';
import _ from 'lodash';
import './AddAliasModal.css';

export const ADD_MODE = "add";
export const EDIT_MODE = "edit";

class AddAliasModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            phoneNumber: "",
            countryCode: ""
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.mode === EDIT_MODE && (nextProps.isOpen && !this.props.isOpen)) {
            this.setState({
                firstName: nextProps.data.firstName,
                lastName: nextProps.data.lastName,
                phoneNumber: nextProps.data.phoneNumber,
                countryCode: nextProps.data.countryCode
            });
            this.props.setCurrentContinentByCountry(nextProps.data.countryCode);
        }
        if ((_.isNil(nextProps.data) && nextProps.data !== this.props.data) || (!nextProps.isOpen && this.props.isOpen)){
            this.clearData();
            this.props.onContinentSet("");
        }
        if (nextProps.continentCode !== this.state.continentCode) {
            this.setState({ continentCode: nextProps.continentCode });
        }
    }

    render() {
        if (!_.isNil(this.props.mode)) {
            return (
                <Modal isOpen={this.props.isOpen} toggle={this.onCancelHandle} className="add-alias-modal-container">
                    <ModalBody>
                        <FormWrapper
                            successMessage={this.getSuccessMessage(this.props.mode)}
                        >
                            <Form onSubmit={this.onSubmit}>
                                {this.renderAliasFormGroups()}
                                <div className="modal-buttons-container">
                                    <Button color='secondary' onClick={this.onCancelHandle}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                                    <Button className="olive-green-btn" type="submit">{this.getButtonLabel(this.props.mode)}</Button>
                                </div>
                            </Form>
                        </FormWrapper>
                    </ModalBody>
                </Modal>
            );
        } else {
            return null;
        }
    }

    getButtonLabel = (mode) => {
        switch (mode) {
            case ADD_MODE:
                return _.get(this.props.translation, 'aliases.add_button');
            case EDIT_MODE:
                return _.get(this.props.translation, 'aliases.edit_button');
            default:
                return '';
        }
    };

    getSuccessMessage = (mode) => {
        switch (mode) {
            case ADD_MODE:
                return _.get(this.props.translation, 'aliases.add_success_message');
            case EDIT_MODE:
                return _.get(this.props.translation, 'aliases.edit_success_message');
            default:
                return '';
        }
    };

    renderAliasFormGroups = () => {
        let paramsList = [
            {
                value: "firstName",
                title: _.get(this.props.translation, sharedLabelsPath.first_name_label),
                isRequired: true
            },
            {
                value: "lastName",
                title: _.get(this.props.translation, sharedLabelsPath.last_name_label),
                isRequired: true
            },
            {
                value: "phoneNumber",
                title: _.get(this.props.translation, sharedLabelsPath.phone_number_label)
            },
            {
                value: "continentCode",
                title: _.get(this.props.translation, sharedLabelsPath.continent_filter_label),
                onChange: this.handleChangeContinent,
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.continents,
                    _.get(this.props.translation, sharedLabelsPath.continents),
                    _.get(this.props.translation, sharedLabelsPath.continent_input_placeholder)
                ),
                isDisabled: !this.props.continents,
                isRequired: true
            }, 
            {
                value: "countryCode",
                title: _.get(this.props.translation, sharedLabelsPath.country_label),
                type: 'select',
                content: Utils.getLocationOptions(
                    this.props.countries,
                    _.get(this.props.translation, sharedLabelsPath.countries),
                    _.get(this.props.translation, sharedLabelsPath.country_input_placeholder)
                ),
                isDisabled: !this.props.countries,
                isRequired: true
            }
        ];

        return [..._.map(paramsList, this.getFormGroup)];
    };

    getFormGroup = (params) => {
        if (!params || typeof (params) !== 'object') {
            return;
        }
        let id = _.kebabCase(params.value);
        return (
            <FormGroup row key={params.title}>
                <Label for={id} sm={3} >{params.title + (params.isRequired ? '*' : '')}</Label>
                <Col sm={9}>
                    <Input type={params.type || 'text'} id={id}
                        value={this.state[params.value]}
                        onChange={params.onChange || this.handleChange(params.value)}
                        placeholder={params.title}
                        required={params.isRequired}
                        disabled={params.isDisabled}
                    >
                    {params.content}
                    </Input>
                </Col>
            </FormGroup>
        );
    };

    handleChange = (fieldKey) => (e) => {
        this.setState({ [fieldKey]: e.target.value });
    };

    handleChangeContinent = (e) => {
        this.props.onContinentSet(e.target.value);
        this.setState({ countryCode: "" });
    };

    onCancelHandle = () => {
        this.clearData();
        this.props.onCancel();
        this.props.onContinentSet("");
    };

    clearData = () => {
        this.setState({
            firstName: "",
            lastName: "",
            phoneNumber: "",
            countryCode: ""
        });
    };

    onSubmit = (e) => {
        e.preventDefault();
        let data = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            phoneNumber: (!_.isNil(this.state.phoneNumber) && this.state.phoneNumber !== "") ? this.state.phoneNumber : null,
            countryCode: this.state.countryCode
        };
        switch (this.props.mode) {
            case ADD_MODE:
                this.props.onAdd(data);
                break;

            case EDIT_MODE:
                data["exposePhone"] = this.props.data.exposePhone;
                data["exposeEmail"] = this.props.data.exposeEmail;
                this.props.onEdit(this.props.id, data);
                break;

            default:
                break;
        }
    };
}

AddAliasModal.propTypes = {
    mode: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    id: PropTypes.string,
    data: PropTypes.object,
    translation: PropTypes.object.isRequired,
    continentCode: PropTypes.string,
    continents: PropTypes.array,
    countries: PropTypes.array,
    onContinentSet: PropTypes.func.isRequired,
    setCurrentContinentByCountry: PropTypes.func.isRequired,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onCancel: PropTypes.func
};

export default AddAliasModal;



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/addAliasModal/AddAliasModal.js